import React, { useMemo } from "react";

import { Button, Box, Grid } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { useTranslation } from "react-i18next";
import AdaptivePopper from "@components_v2/adaptive-popper";
import BaseFilterChip from "@components_v2/search-filters/base-filter-chip";

export const SearchExpand = ({ isDisabled, component, onDelete = null, onCancel, onSave, item, maxCount }) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleDelete = (event) => {
        event.stopPropagation();
        onDelete();
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const wrapperWidthProps = useMemo(() => {
        switch (item.type) {
            case "assetDateRange":
                return {
                    minWidth: 328,
                };
            case "categories":
                return {
                    minWidth: 600,
                    maxWidth: 600,
                };
            default:
                return {
                    minWidth: 328,
                    maxWidth: 328,
                };
        }
    }, [item]);

    const popperHeightProps = useMemo(() => {
        switch (item.type) {
            case "categories":
                return {
                    minHeight: 200,
                    maxHeight: 600,
                };
            default:
                return {};
        }
    }, [item]);

    return (
        <>
            {item.essential ? (
                <BaseFilterChip
                    item={item}
                    selected={open}
                    onClick={handleClick}
                    onDelete={item.value ? handleDelete : undefined}
                />
            ) : (
                <BaseFilterChip
                    item={item}
                    selected={open}
                    styleOverrides={{
                        active: true,
                        titleColor: "primary",
                        arrowColor: theme.palette.secondary[400],
                        badgeSx: { ml: 2, mr: 1 },
                    }}
                    onClick={handleClick}
                    onDelete={handleDelete}
                />
            )}
            <AdaptivePopper
                open={open}
                anchorEl={anchorEl}
                placement={"bottom-start"}
                disablePortal={true}
                wrapperSx={{
                    ...wrapperWidthProps,
                    p: theme.spacing(2),
                    "& .MuiAutocomplete-listbox": { maxHeight: "300px" },
                }}
                minHeight={popperHeightProps.minHeight}
                maxHeight={popperHeightProps.maxHeight}
                fitContent={true}
                onClickAway={handleClose}
            >
                {component}
                <Grid
                    container
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    data-role={"footer"}
                >
                    <Box>{maxCount}</Box>
                    <Box mt={1} sx={{ textAlign: `right` }}>
                        <Button
                            type={"button"}
                            variant={"text"}
                            size={"small"}
                            color={"inherit"}
                            minWidth={1}
                            onClick={() => {
                                onCancel && onCancel();
                                handleClose();
                            }}
                        >
                            {t("common::label::Cancel")}
                        </Button>
                        <Button
                            type={"button"}
                            variant={"contained"}
                            size={"small"}
                            color={"primary"}
                            minWidth={1}
                            disabled={isDisabled}
                            sx={{ marginLeft: `4px` }}
                            onClick={() => {
                                onSave && onSave();
                                handleClose();
                            }}
                        >
                            {t("common::label::Apply")}
                        </Button>
                    </Box>
                </Grid>
            </AdaptivePopper>
        </>
    );
};

export default SearchExpand;
